import React from 'react'
import { Icon as ManyUIIcon, l, palettes } from '@manychat/manyui'

import * as cardStyles from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/Card.styles'
import { CardPreview } from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/CardPreview'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { NoButtonStatContextProvider } from 'common/builder/components/chart/FlowChart/contexts/ButtonStatContext'
import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import Icon from 'common/builder/components/chart/FlowChart/nodes/shared/Icon'
import PersonalizedText from 'common/builder/components/chart/FlowChart/nodes/shared/PersonalizedText'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartCard } from 'common/builder/components/chart/FlowChart/types/FlowChartCardsBlock'

const UrlIcon = convertToIconString(ManyUIIcon.Link, {
  size: sharedStyles.IconSizes.LARGE,
  color: palettes.semantic.primary,
})

interface CardProps {
  card: FlowChartCard
  withShadow: boolean
}

export const Card = ({ card, withShadow }: CardProps) => {
  let viewStyles = withShadow ? cardStyles.CardWithShadow : cardStyles.Card
  viewStyles = card.isHidden ? { ...viewStyles, ...cardStyles.CardHidden } : viewStyles

  /**
   * We should not show CTR for buttons in hidden cards
   */
  const Wrapper = card.isHidden ? NoButtonStatContextProvider : React.Fragment

  return (
    <Wrapper>
      <InteractiveBlockContainer exposeBlockCoordinates id={card.id} style={viewStyles}>
        <CardPreview card={card} />

        <view style={cardStyles.Content}>
          {card.url && (
            <view style={cardStyles.UrlICon}>
              <Icon icon={UrlIcon} />
            </view>
          )}

          <PersonalizedText style={cardStyles.Title}>
            {card.title || l.translate('Add a title')}
          </PersonalizedText>

          <PersonalizedText style={cardStyles.Subtitle}>
            {card.subTitle || l.translate('Add a subtitle')}
          </PersonalizedText>

          {card.buttons.map((button) => (
            <Button button={button} key={button.id} />
          ))}
        </view>
      </InteractiveBlockContainer>
    </Wrapper>
  )
}
